import React, { useState } from 'react'
import navimage from "../../assets/logo.jpg"
import "./Navbar.css"
import menu from "../../assets/menu.png"
import close from "../../assets/close.png"
import { Link } from 'react-router-dom'

const Navbar = () => {
  

  //state for menu 
  const [isMenuOpen,setIsMenuOpen] =useState(false);
  
  //function to handle icon 
  const handleMenu =()=>{
    setIsMenuOpen(!isMenuOpen);
  }

  const onCloseNavlist=()=>{
    setIsMenuOpen(false);
  }
  
  //const navigate = useNavigate();
  
 
  
  return (
    <div className='fix'>
    <div className='navbg'>
        {/* logo icon */}
        <div className='navimage'>
            <img src={navimage} alt="" srcSet="" />
        </div>

        {/*hamburger icon */}
        <div className='hamburger' onClick={handleMenu}>
           <img src={isMenuOpen ? close : menu} alt=""  className='hamburger _icon'/>
        </div>
        <div className={`navlist ${isMenuOpen ? "show" :""}`}>
        <ul>
            <li><Link to="/" onClick={onCloseNavlist}>Home</Link></li>
            <li><Link to="/projects" onClick={onCloseNavlist}>Projects</Link></li>
            <li><Link to="/gallery" onClick={onCloseNavlist}>Gallery</Link></li>
            <li><Link to="/enquiries" onClick={onCloseNavlist}>Enquiry</Link></li>
            <li><Link to="/contactus" onClick={onCloseNavlist}>Contact us</Link></li>
        </ul>
      </div>
    </div>
    </div>
  )
}

export default Navbar